import { render, staticRenderFns } from "./AttributeNumberFilter.vue?vue&type=template&id=2cf09f30&scoped=true"
import script from "./AttributeNumberFilter.vue?vue&type=script&lang=ts"
export * from "./AttributeNumberFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf09f30",
  null
  
)

export default component.exports